/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * @enum
 * Enum for ResponseType values
 * @property {string} ARRAYBUFFER - To download response content as an [ArrayBuffer]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer}
 * @property {string} BLOB - To download content as a [binary/blob] {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob}
 * @property {string} DOCUMENT - This downloads content as a document or stream
 * @property {string} JSON - To download response content as a json
 * @property {string} STREAM - To download response as a [stream]{@link https://nodejs.org/api/stream.html}
 * @property {string} TEXT - For downloading response as a text
 */
export var ResponseType;
(function (ResponseType) {
  ResponseType["ARRAYBUFFER"] = "arraybuffer";
  ResponseType["BLOB"] = "blob";
  ResponseType["DOCUMENT"] = "document";
  ResponseType["JSON"] = "json";
  ResponseType["RAW"] = "raw";
  ResponseType["STREAM"] = "stream";
  ResponseType["TEXT"] = "text";
})(ResponseType || (ResponseType = {}));